import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgLabelBadge = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 55, height: 16, viewBox: "0 0 55 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.3467 8.83984H17.1475L18.2568 5.95996L19.3467 8.83984Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M27.5273 8.41992C28.5473 8.41992 29.0576 8.68001 29.0576 9.41992C29.0576 10.3499 28.1275 10.4805 27.4775 10.4805H26.3477V8.41992H27.5273Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M27.3574 5.5C28.3073 5.5 28.7577 5.75 28.7578 6.37988C28.7578 6.98985 28.3077 7.3398 27.4678 7.33984H26.3477V5.5H27.3574Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53 0C54.1046 7.40893e-07 55 0.895431 55 2V14C55 15.1046 54.1046 16 53 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H53ZM7.91992 4.45996V11.54H12.1895V10.4199H9.17969V4.45996H7.91992ZM17.7471 4.45996L14.667 11.54H16.0771L16.7168 9.91992H19.7871L20.4473 11.54H21.8867L18.8369 4.45996H17.7471ZM25.0879 4.45996V11.54H27.6377C28.9775 11.54 30.3171 11.0201 30.3174 9.48047C30.3174 8.53061 29.6779 7.9297 28.7881 7.80957V7.79004C29.5178 7.56998 30.0175 7.03997 30.0176 6.24023C30.0176 4.95025 28.9176 4.45997 27.8477 4.45996H25.0879ZM34.0625 4.45996V11.54H38.9326V10.4199H35.3223V8.41992H38.5723V7.36035H35.3223V5.55957H38.752V4.45996H34.0625ZM42.666 4.45996V11.54H46.9355V10.4199H43.9258V4.45996H42.666Z", fill: props.fill }));
});
export default SvgLabelBadge;
